import { Box, Card, Grid, Typography, TextField, Button, CircularProgress, Modal } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Addemail from '../../components/email/Addemail';
import { apipost, apiput } from '../../service/api';
import { SectionCard, SectionHeader, FieldRow } from './LeadViewStyles';

const BorrowerInformation = ({ data, setUserAction }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ ...data });
  const [isEdited, setIsEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const userId = localStorage.getItem('user_id');
  useEffect(() => {
    setFormData({ ...data });
  }, [data]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setIsEdited(true);
  };

  const handleConvertToLoan = async () => {
    setLoading(true);
    setLoadingMessage('Converting to Loan');
    try {
      console.log('this is the data we are sending in for the loan convert',data);
      const result = await apipost('loan/convert', { ...data, userId });
      if (result.status === 201) {
        toast.success('Lead converted to loan successfully!');
        setUserAction(result);
      } else {
        toast.error('Failed to convert lead to loan.');
      }
    } catch (error) {
      toast.error('Failed to convert lead to loan.');
    } finally {
      setLoading(false);
      setLoadingMessage('');
    }
  };

  const handleInviteToLoan = async () => {
    setLoading(true);
    setLoadingMessage('Emailing Borrower Invite');
    try {
      const result = await apipost('loan/invite', { ...data, userId });
      if (result.status === 201) {
        toast.success('Borrower invite emailed successfully!');
        setUserAction(result);
      } else {
        toast.error('Failed to email borrower invite.');
      }
    } catch (error) {
      toast.error('Failed to email borrower invite.');
    } finally {
      setLoading(false);
      setLoadingMessage('');
    }
  };

  const handleSave = async () => {
    const result = await apiput(`lead/edit/${data._id}`, formData);
    setUserAction(result);
    if (result.status === 200) {
      toast.success('Lead information updated successfully!');
      setIsEdited(false);
    } else {
      toast.error('Failed to update lead information.');
    }
  };

  return (
    <div>
      <Addemail open={open} handleClose={handleClose} _id={data?._id} receiver={data} setUserAction={setUserAction} />

      <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px' }}>
        <Box p={3}>
          {/* Action Buttons Banner */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
              mb: 3,
              p: 1.5,
              bgcolor: 'primary.lighter',
              borderRadius: 1.5,
            }}
          >
            <Button variant="contained" color="primary" onClick={handleInviteToLoan}>
              Invite To Loan
            </Button>
            <Button variant="contained" color="primary" onClick={handleConvertToLoan}>
              Convert To Loan
            </Button>
          </Box>

          {/* Contact Details */}
          <SectionCard>
            <SectionHeader>Contact Details</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="First Name"
                  name="firstName"
                  value={formData.firstName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Mobile"
                  name="phoneNumber"
                  value={formData.phoneNumber || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Preferred Contact Method"
                  name="preferredContactMethod"
                  value={formData.preferredContactMethod || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Last Name"
                  name="lastName"
                  value={formData.lastName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Email"
                  name="emailAddress"
                  value={formData.emailAddress || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  onClick={handleOpen}
                  style={{ cursor: 'pointer' }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Best Time to Contact"
                  name="bestTimeToContact"
                  value={formData.bestTimeToContact || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Purchase & Refinance side by side */}
          <FieldRow>
            <Grid item xs={12} sm={6}>
              <SectionCard sx={{ mb: 0, height: '100%' }}>
                <SectionHeader>Purchase Information</SectionHeader>
                <TextField
                  label="What is your Purchase timeframe?"
                  name="purchaseTimeframe"
                  value={formData.purchaseTimeframe || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Purchase Price Range"
                  name="purchasePriceRange"
                  value={formData.purchasePriceRange || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Are you Pre-Approved?"
                  name="areYouPreApproved"
                  value={formData.areYouPreApproved || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Would you like a Pre-Approval or Comparison?"
                  name="preApprovalComparison"
                  value={formData.preApprovalComparison || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Are you working with an agent?"
                  name="workingWithAgent"
                  value={formData.workingWithAgent || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </SectionCard>
            </Grid>
            <Grid item xs={12} sm={6}>
              <SectionCard sx={{ mb: 0, height: '100%' }}>
                <SectionHeader>Refinance Information</SectionHeader>
                <TextField
                  label="Years you expect to live in Home?"
                  name="yearsInHome"
                  value={formData.yearsInHome || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Preferred Interest Rate or Monthly Savings to move forward?"
                  name="preferredRateOrSavings"
                  value={formData.preferredRateOrSavings || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="What is your estimated Credit Score?"
                  name="estimatedCreditScore"
                  value={formData.estimatedCreditScore || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="How soon would you like to close on your refinance (Date)?"
                  name="closingDate"
                  value={formData.closingDate || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </SectionCard>
            </Grid>
          </FieldRow>

          {/* Save Button */}
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button variant="contained" color="primary" onClick={handleSave} disabled={!isEdited}>
              Save
            </Button>
          </Box>
        </Box>
      </Card>

      <Modal
        open={loading}
        aria-labelledby="loading-modal-title"
        aria-describedby="loading-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>
            {loadingMessage}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default BorrowerInformation;
